"use strict";
/**
 * Weekly Report V2 — Treatment Evaluation Types
 *
 * Types for the treatment response model: physiological phases,
 * expected metric responses, response matrix entries, and area inference.
 * Used by both backend (services, response matrix) and frontend (display).
 *
 * Treatment evaluations differ from product evaluations:
 * - Treatments have physiological response phases (acute -> maturation -> waning)
 * - Treatments target specific areas (area-level signals, not face-level)
 * - Expected metric responses carry per-metric confidence and direction
 * - Area inference enables progressive profiling when treatment area is unknown
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentExpectedMetricDirection = exports.TreatmentExpectedMetricConfidence = exports.TreatmentResponsePhaseName = void 0;
const constants_1 = require("../constants");
// ============================================================================
// TREATMENT RESPONSE PHASE NAMES
// ============================================================================
/**
 * Physiological response phases for in-clinic treatments.
 * Based on peer-reviewed dermatological literature.
 */
exports.TreatmentResponsePhaseName = {
    ACUTE: 'acute',
    PROLIFERATIVE: 'proliferative',
    PRESENTATION: 'presentation',
    MATURATION: 'maturation',
    PLATEAU: 'plateau',
    WANING: 'waning',
};
// ============================================================================
// EXPECTED METRIC CONFIDENCE
// ============================================================================
/**
 * Confidence tier for expected physiological metric responses.
 * Semantically distinct from AcuteEventConfidence (detection events).
 * Each metric carries its own evidence strength per phase.
 */
exports.TreatmentExpectedMetricConfidence = {
    LOW: 'low',
    MODERATE: 'moderate',
    HIGH: 'high',
};
/**
 * Direction of expected metric response.
 * Indicates whether the metric should increase or decrease over the course of the treatment.
 */
exports.TreatmentExpectedMetricDirection = {
    INCREASING: 'increasing',
    DECREASING: 'decreasing',
};
//# sourceMappingURL=treatmentEvaluation.js.map